module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_Wood.d527d994.jpg";